import { Component, type ReactNode } from "react";

/**
 * Rete di salvataggio: se una pagina non si carica o va in errore durante il
 * render, invece di uno schermo bianco mostra un messaggio con "Ricarica".
 * Copre il caso limite in cui anche il retry dei chunk non è bastato.
 */
export class RouteErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="fixed inset-0 flex flex-col items-center justify-center gap-4 px-8 text-center"
          style={{ background: "#E9E4DE" }}
        >
          <p className="text-[15px] text-[#6A6661]">
            Qualcosa è andato storto nel caricamento della pagina.
          </p>
          <button
            onClick={() => {
              // I tentativi automatici sono a numero chiuso per non entrare in ciclo,
              // ma restano spesi per tutta la sessione: un guasto momentaneo di prima
              // lascerebbe senza recupero anche dopo. Se l'utente ricarica a mano,
              // sta chiedendo esplicitamente un nuovo tentativo: azzeriamo il conto.
              try {
                sessionStorage.removeItem("cl-chunk-reloaded");
                sessionStorage.removeItem("cl-boot-riprovato");
              } catch {
                // sessionStorage non disponibile: la ricarica si fa lo stesso.
              }
              // Reload cache-busting: cambia l'URL così il WebView non riusa l'index
              // vecchio in cache e riscarica quello aggiornato (che referenzia i chunk giusti).
              const u = new URL(window.location.href);
              u.searchParams.set("_r", Date.now().toString());
              window.location.replace(u.toString());
            }}
            className="px-5 py-2.5 rounded-full bg-[#86694B] text-white font-semibold active:scale-[0.98] transition-transform"
          >
            Ricarica
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
